import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=581c08a0&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=581c08a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c08a0",
  null
  
)

export default component.exports